import { useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';

export const useDiscounts = () => {
  const [discounts, setDiscounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDiscounts = async () => {
    setLoading(true);
    try {
      // Using the new endpoint that returns all discount types
      const response = await axiosInstance.get('/api/all-discounts');
      setDiscounts(response.data.data || []);
      setError(null);
    } catch (error) {
      console.error('Error fetching discounts:', error);
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDiscounts();
  }, []);

  return { discounts, loading, error, refetch: fetchDiscounts };
}; 